import React, { useState, useMemo, Fragment, useEffect, useRef } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';

// Componentes
import PaymentBusinessPartnerHeader from './Common/Headers/PaymentBusinessPartnerHeader';
import PaymentAccountHeader from './Common/Headers/PaymentAccountHeader';
import PaymentDocTypeRadio from './Common/PaymentDocTypeRadio';
import PaymentAccounts from './Common/Body/PaymentAccounts';
import PaymentFooter from './Common/PaymentFooter';

import { Toasty, useToasty } from 'hooks/Toasty';
import { Assignment } from '@material-ui/icons';
import { WithApp } from 'contexts/appContext';
import { useParams } from 'react-router';
import moment from 'moment';

// WS
import { wsCreate } from 'services/WService';
import PaymentDocuments from './Common/Body/PaymentDocuments';
import PaymentDocumentsAcomplished from './Common/Body/PaymentDocumentsAcomplished';
import { wsGetAll } from 'services/WService';
import PymtCustomerImport from './Common/Body/PymtCustomerImport';
import PaymentDocumentsImport from './Common/Body/PaymentDocumentsImport';
import SweetAlert from 'react-bootstrap-sweetalert';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import stylesForm from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';

// const paymentTypes = {
//   CASH: 'CH',
//   CREDIT: 'CR',
//   CHECK: 'CK',
//   LETTER: 'LT',
//   TRANSFER: 'TR',
// }

const defaultPayment = {
  type: 'CH',
  CashSum: 0,
};

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...stylesForm
}));

function NewPayment(props) {
  const classes = useStyles();
  const bpId = useParams().id;
  const { paymentType } = props;
  const title = useMemo(() => {
    if (paymentType === 'ACCOMPLISHED') return 'Nuevo pago efectuado';
    return 'Nuevo pago recibido';
  }, [paymentType]);

  const [notify, showNotify] = useToasty();
  const [DocType, setDocType] = useState(props.DefaultDocType);

  // Pago tipo Proveedor / Cliente dependiendo
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [payment, setPayment] = useState({
    ...defaultPayment,
    base_business_partner_id: bpId === '0' ? undefined : bpId,
    DocDate: moment().format('YYYY-MM-DD'),
  });
  const [zones, setZones] = useState([]);
  const [businessPartner, setBusinessPartner] = useState(undefined);
  const [isEmployee, setIsEmployee] = useState(false);
  const [payWithDocuments, setPayWithDocuments] = useState(true);

  const [totalAmount, setTotalAmount] = useState(0);
  const [documents, setDocuments] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [checks, setChecks] = useState([]);

  const inputFileRef = useRef(null);
  const [importData, setImportData] = useState(undefined);
  const inputFileDocRef = useRef(null);
  const [importDocumentData, setImportDocumentData] = useState(undefined);
  const [importedData, setImportedData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [processingDocument, setProcessingDocument] = useState(false);
  const [alert2, setAlert2] = useState(null);
  const [selectionModel, setSelectionModel] = useState([]);
  const [aviableAccounts, setAviableAccounts] = useState([]);

  async function process() {
    let paymentData = { DocType, type: paymentMethod };
    //#region Validación DocType
    // Cuenta
    if (DocType === 'A') {
      paymentData = {
        ...paymentData,
        CardName: payment.CardName,
        Address: payment.Address,
        base_zone_id: payment.base_zone_id,
      };
      if (accounts.length === 0) {
        alert('Elija al menos una cuenta');
        return;
      }
      paymentData.accounts = [...accounts];
    }

    // Proveedor / cliente
    if (['S', 'C'].includes(DocType)) {
      paymentData = { ...paymentData, base_business_partner_id: payment.base_business_partner_id };

      // Pago con documentos
      if (payWithDocuments) {
        if (documents.length === 0) {
          return alert('Elija al menos un documento');
        }

        //  Validando fechas de documentos
        let DocDateMoment = moment(payment.DocDate);
        let documentErrors = documents.filter((doc) => {
          return DocDateMoment.isBefore(moment(doc.TaxDate));
        });
        if (documentErrors.length > 0) {
          let message = `Fec. Contable inválida (${DocDateMoment.format(
            'DD-MM-YYYY',
          )}), no se puede contabilizar pagos de documentos futuros (${moment(
            documentErrors[0].TaxDate,
          ).format('DD-MM-YYYY')}).`;
          alert(message);
          return;
        }

        paymentData.documents = [...documents];
      } else {
        if (payment.base_zone_id === undefined) {
          showNotify('Seleccione una zona', 'info');
          return;
        }
        paymentData.base_zone_id = payment.base_zone_id;
      }
    }

    //#endregion

    paymentData = {
      ...paymentData,
      DocCurr: payment.DocCurr || 'S/',
      CFWId: payment.CFWId,
      DocDate: payment.DocDate,
      Comments: payment.Comments,
    };

    //#region Método de pago
    // Cash
    if (paymentMethod === 'CH') {
      if (parseFloat(payment.CashSum) !== totalAmount) {
        return alert('El monto a pagar no puede ser menor al total a pagar');
      }
      paymentData = { ...paymentData, CashSum: payment.CashSum };
    }

    // Transferencia
    if (paymentMethod === 'TR') {
      if (parseFloat(payment.TrsfrSum) !== totalAmount) {
        return alert('El monto a pagar no puede ser menor al total a pagar');
      }
      paymentData = {
        ...paymentData,
        TrsfrAcct: payment.TrsfrAcct,
        TrsfrSum: payment.TrsfrSum,
        TrsfrDate: payment.TrsfrDate,
        TrsfrRef: payment.TrsfrRef,
      };
    }

    // Cheque
    if (paymentMethod === 'CK') {
      if (parseFloat(payment.CheckSum) !== totalAmount) {
        return alert('El monto a pagar no puede ser menor al total a pagar');
      }
      paymentData = {
        ...paymentData,
        CheckSum: payment.CheckSum,
        checks: [...checks],
      };
    }

    // TODO Crédito, verificar
    if (paymentMethod === 'CR') {
      // TODO Verificar como esta en el antiguo
      if (parseFloat(payment.CreditSum) !== totalAmount) {
        return alert('El monto a pagar no puede ser menor al total a pagar');
      }
    }
    //#endregion

    let entity = 'pymt/received-payment';
    if (paymentType === 'ACCOMPLISHED') {
      entity = 'pymt/accomplished-payment';
    }
    let res = await wsCreate(entity, paymentData);
    if (res.success !== true) {
      return alert(res.message);
    }
    alert(res.message);
    window.location.reload();
  }


  async function processMultiple(selectionModel, aviableAccounts) {

    if (!importDocumentData || importDocumentData.length === 0) {
      alert("No hay data importada para procesar");
      return;
    }

    const selectedRows = aviableAccounts.filter((account) =>
      selectionModel.includes(`${account.AcctCode}-${account.CardName}-${account.Address}`)
    );

    if (selectedRows.length === 0) {
      alert("Seleccione al menos un registro");
      return;
    }

    const payments = selectedRows.map((item) => ({
      DocType: "A",
      type: paymentMethod,
      CardName: item.CardName,
      Address: item.Address,
      base_zone_id: item.base_zone_id,
      accounts: [
        {
          AcctCode: item.AcctCode,
          SumApplied: Number(item.CashSum),
        },
      ],
      DocCurr: payment.DocCurr || "S/",
      CFWId: item.CFWName,
      DocDate: item.DocDate,
      Comments: item.Comments,
      CashSum: Number(item.CashSum),
    }));

    const totalSelected = payments.reduce((acc, p) => acc + p.CashSum, 0);

    if (totalSelected <= 0) {
      return alert("El monto seleccionado debe ser mayor a cero");
    }

    let entity = "";
    if (paymentType === "ACCOMPLISHED") {
      entity = "pymt/accomplished-payment/multiple-documents";
    }else{
      return alert("No hay función para esta vista.");
    }

    let res = await wsCreate(entity, { payments });

    if (res.success !== true) {
      return alert(res.message);
    }

    alert(res.message);
    window.location.reload();
  }

  async function listZones() {
    let res = await wsGetAll('base/zone');
    if (res.success) {
      setZones(res.data);
    }
  }

  async function importExcelDocument(e) {
    if (e.target.files.length === 0) return;

    let formData = new FormData();
    formData.append('import', e.target.files[0]);

    let res = await wsCreate('pymt/accomplished-payment/store-excel', formData);
    inputFileDocRef.current.value = '';
    
    if (res.success) {
      setImportDocumentData(res.data);
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function importExcel(e) {
    if (e.target.files.length === 0) return;

    let formData = new FormData();
    formData.append('import', e.target.files[0]);

    let res = await wsCreate('pymt/received-payment/store-excel', formData);
    inputFileRef.current.value = '';
    
    if (res.success) {
      setImportData(res.data);
    } else {
      inputFileRef.current.value = '';
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    switch (DocType) {
      case 'S':
      case 'C':
        setPayment((payment) => ({ ...payment, CardCode: undefined, Address: undefined }));
    }
  }, [DocType]);

  useEffect(() => {
    listZones();
  }, []);

  const confirmProcessDocuments = () => {
    setAlert2(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de procesar los documentos seleccionados?"
        onConfirm={async () => {
          setAlert2(null);
          await handleProcessDocuments(); // aquí ya ejecutas la lógica real
        }}
        onCancel={() => setAlert2(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Esta acción no se puede revertir.
      </SweetAlert>,
    );
  };

  const handleProcessDocuments = async () => {
    console.log("Procesando documentos seleccionados:", documents);
    
    if (documents.length === 0) {
      showNotify("Debe seleccionar al menos un documento para procesar", "warning");
      return;
    }

    setProcessing(true);
    
    try {
      // Arrays globales
      const documentsArray = [];
      const rendirCuentasArray = [];
      let totalSum = 0;

      documents.forEach(doc => {
        const isDocument =
          doc.TipoComprobante && doc.TipoComprobante.trim() !== '' &&
          doc.Serie && doc.Serie.trim() !== '' &&
          doc.Correlativo !== null && doc.Correlativo !== undefined && doc.Correlativo !== '';

        const itemDocument = {
          Serie: doc.Serie || '',
          Correlativo: doc.Correlativo || '',
          TipoComprobante: doc.TipoComprobante || '',
          Sum: parseFloat(doc.TotalPagar || 0),
          TaxDate: doc.FechaContable,
          base_business_partner_id: doc.base_business_partner_id,
          CardCode: doc.CardCode,
          CardType: doc.CardType,
          base_zone_id: doc.base_zone_id,
          Comments: doc.Comentario || ''
        };
        const itemAccount = {
          Sum: parseFloat(doc.TotalPagar || 0),
          TaxDate: doc.FechaContable,
          base_business_partner_id: doc.base_business_partner_id,
          CardCode: doc.CardCode,
          CardType: doc.CardType,
          base_zone_id: doc.base_zone_id,
          Comments: doc.Comentario || ''
        };

        if (isDocument) {
          documentsArray.push(itemDocument);
        } else {
          rendirCuentasArray.push(itemAccount);
        }

        totalSum += parseFloat(doc.TotalPagar || 0);
      });

      // Payload único
      const payload = {
        type: "CH",
        documents: documentsArray,
        rendirCuentas: rendirCuentasArray,
        CFWId: "61",
        CashSum: Math.round(totalSum * 100) / 100
      };

      console.log("Payload final a enviar:", payload);

      // Validar
      if (payload.documents.length === 0 && payload.rendirCuentas.length === 0) {
        showNotify("No hay documentos válidos para procesar", "warning");
        setProcessing(false);
        return;
      }

      // Una sola petición
      const response = await wsCreate('pymt/received-payment/process-mixed-documents', payload);

      if (response.success) {
        showNotify("Documentos procesados exitosamente", "success");
        setImportData(undefined);
        setImportedData([]);
        setDocuments([]);
      } else {
        showNotify(`Error al procesar: ${response.message}`, "error");
      }
    } catch (error) {
      console.error("Error procesando documentos:", error);
      showNotify("Error al procesar los documentos", "error");
    } finally {
      setProcessing(false);
    }

  };

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert2}

      <input
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style={{ display: 'none' }}
        onChange={importExcel}
        ref={inputFileRef}
      />

      <input
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style={{ display: 'none' }}
        onChange={importExcelDocument}
        ref={inputFileDocRef}
      />

      <CardContainer title={title} icon={<Assignment />} iconColor="primary">
        {/* RadioButton de tipos de pago */}

        {/* Filtro de socios negocio */}
        {!importData ? (
          <>
            <PaymentDocTypeRadio DocType={DocType} setDocType={setDocType} bpId={bpId} />
            {(DocType === 'S' || DocType === 'C') && (
              <PaymentBusinessPartnerHeader
                paymentType={paymentType}
                isEmployee={isEmployee}
                setIsEmployee={setIsEmployee}
                businessPartner={businessPartner}
                setBusinessPartner={setBusinessPartner}
                payWithDocuments={payWithDocuments}
                setPayWithDocuments={setPayWithDocuments}
                payment={payment}
                zones={zones}
                setPayment={setPayment}
                DocType={DocType}
                bpId={bpId}
                paymentMethod={paymentMethod}
                processing={processing}
                onImport={() => inputFileRef.current.click()}
                documents={documents}
                showNotify={showNotify}
              />
            )}
          </>
        ) : (
          // importData?.data?.length > 0 && (
            // <>
            <PymtCustomerImport
              importData={importData}
              setImportedData={setImportedData}
              setPayWithDocuments={setPayWithDocuments}
              paymentMethod={paymentMethod}
              processing={processing}
              onImport={() => inputFileRef.current.click()}
              onProcessDocuments={confirmProcessDocuments}/>
            // </>
          // )
        )}


        {/* Destinatario de pago para tipo cuenta */}
        {DocType === 'A' && (
          <PaymentAccountHeader
            payment={payment}
            setPayment={setPayment}
            zones={zones}
            paymentMethod={paymentMethod}
            processing={processing}
            processingDocument={processingDocument}
            onImport={() => inputFileDocRef.current.click()}
            importDocumentData={importDocumentData}
            setImportDocumentData={setImportDocumentData}
            processMultiple={processMultiple}
            selectionModel={selectionModel}
            aviableAccounts={aviableAccounts}
            />
        )}
      </CardContainer>

      {/* Listado de documentos Recibidos*/}
      {/* {payment.base_business_partner_id !== undefined && DocType !== 'A' && payWithDocuments && paymentType === 'RECEIVED' && (
        <PaymentDocuments
          zoneId={payment.base_zone_id}
          showNotify={showNotify}
          setDocuments={setDocuments}
          setTotalAmount={setTotalAmount}
          businessPartner={businessPartner}
        />
      )} */}
      {!importData ? (
        payment.base_business_partner_id !== undefined && DocType !== 'A' && payWithDocuments && paymentType === 'RECEIVED' ? (
          <PaymentDocuments
            zoneId={payment.base_zone_id}
            showNotify={showNotify}
            setDocuments={setDocuments}
            setTotalAmount={setTotalAmount}
            businessPartner={businessPartner}
          />
        ) : payment.base_business_partner_id !== undefined && DocType !== 'A' && payWithDocuments && paymentType === 'ACCOMPLISHED' ? (
          <PaymentDocumentsAcomplished
            zoneId={payment.base_zone_id}
            showNotify={showNotify}
            setDocuments={setDocuments}
            setTotalAmount={setTotalAmount}
            businessPartner={businessPartner}
          />
        ) : undefined
      ) : (
        payWithDocuments && (
          <PaymentDocumentsImport
            showNotify={showNotify}
            setDocuments={setDocuments}
            setTotalAmount={setTotalAmount}
            importedData={importData}
            isImportMode={true}
          />
        )
      )}

      {/* Listado de documentos Efectuados*/}
      {/* {payment.base_business_partner_id !== undefined && DocType !== 'A' && payWithDocuments && paymentType === 'ACCOMPLISHED' && (
        <PaymentDocumentsAcomplished
          zoneId={payment.base_zone_id}
          showNotify={showNotify}
          setDocuments={setDocuments}
          setTotalAmount={setTotalAmount}
          businessPartner={businessPartner}
        />
      )} */}

      {/* Listado de Cuentas */}
      {DocType === 'A' && (
        <PaymentAccounts
          importDocumentData={importDocumentData}
          accounts={accounts}
          setAccounts={setAccounts}
          paymentType={paymentType}
          totalAmount={totalAmount}
          setTotalAmount={setTotalAmount}
          selectionModel={selectionModel}
          setSelectionModel={setSelectionModel}
          aviableAccounts={aviableAccounts}
          setAviableAccounts={setAviableAccounts}
        />
      )}

      {/* Métodos de pago y botón procesar */}
      {!importData && !importDocumentData && (
        <CardContainer icon={null}>
          <PaymentFooter
            payWithDocuments={payWithDocuments}
            showNotify={showNotify}
            totalAmount={totalAmount}
            setTotalAmount={setTotalAmount}
            paymentType={paymentType}
            payment={payment}
            setPayment={setPayment}
            checks={checks}
            setChecks={setChecks}
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
            process={process}
            processing={processing}
            setProcessing={setProcessing}
            onImport={() => inputFileRef.current.click()}
          />
        </CardContainer>
      )}
    </Fragment>
  );
}

export default WithApp(NewPayment);
